import {
  configureStore,
  createSerializableStateInvariantMiddleware,
  isPlain,
} from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import authReducer from "../reducers/authReducer";
import dataReducer from "../reducers/dataReducer";
import fleetReducer from "../reducers/fleetReducer";
import generalReducer from "../reducers/generalReducer";
import mapReducer from "../reducers/mapReducer";

// Allow dates
const isSerializable = (value: unknown) =>
  value instanceof Date || isPlain(value);

const serializableMiddleware = createSerializableStateInvariantMiddleware({
  isSerializable,
});

export const store = configureStore({
  devTools: true,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    serializableMiddleware,
  ],
  reducer: {
    general: generalReducer,
    auth: authReducer,
    data: dataReducer,
    fleet: fleetReducer,
    map: mapReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
